import React, { useState } from 'react';
import { Box, Container, TextField, Button, Typography } from '@mui/material';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Credenciales fijas
  const validUsername = 'DC Client';
  const validPassword = 'youcame1tostay';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === validUsername && password === validPassword) {
      onLogin();
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        backgroundImage: `linear-gradient(rgba(3,116,206, 0.6), rgba(3,116,206, 0.6)), url(${process.env.PUBLIC_URL}/login.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          backgroundColor: 'rgba(255,255,255,0.85)',
          p: { xs: 3, sm: 4 },
          borderRadius: 2,
          textAlign: 'center',
          width: { xs: '90%', md: '50rem' }
        }}
      >
        {/* Logo en la parte superior */}
        <Box sx={{ mb: 3 }}>
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/Logo definitivo DC-02.png`}
            alt="Logo"
            sx={{
              width: { xs: '10rem', sm: '15rem' },
              height: 'auto',
              mx: 'auto',
            }}
          />
        </Box>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              backgroundColor: 'rgb(3,116,206)',
              height: '3rem',
              fontSize: { xs: '0.9rem', sm: '1rem' },
            }}
          >
            Sign In
          </Button>
        </form>
      </Container>
    </Box>
  );
};

export default Login;
